export enum VehicleType {
  Car = "car",
  Scooter = "scooter",
  UnPedalScooter = "un-pedal-scooter",
  Bike = "bike",
}
